import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { DocumentPagePreview } from '@/components/elements/DropScan/dropScan.types';

import { ImgSquare, ImgThumbInner, ImgThumbOuter, Wrapper } from './ScanPreview.styles';

interface Props {
  isSmallViewVersion?: boolean;
  isFlex?: boolean;
  isMobile?: boolean;
  activePage?: number;
  documentPagesPreview?: DocumentPagePreview[];
  onSelectPage?: (documentPagesPreview: DocumentPagePreview, pageIndex: number) => void;
}

const ScanPagePreview: React.FC<Props> = ({
  isSmallViewVersion,
  isFlex,
  isMobile,
  activePage,
  documentPagesPreview,
  onSelectPage,
}) => {
  return (
    <Wrapper
      isSmallViewVersion={isSmallViewVersion}
      isFlex={isFlex}
      direction={isSmallViewVersion || isMobile ? 'row' : 'column'}
    >
      {documentPagesPreview?.map((documentPage, index) => (
        <Box key={documentPage.id}>
          <ImgThumbOuter active={activePage === index} onClick={() => onSelectPage?.(documentPage, index)}>
            <ImgThumbInner>
              <Box
                data-testid="page_index"
                width="20px"
                height="20px"
                background="background3"
                justify="center"
                align="center"
                round="button2Round"
                style={{ position: 'absolute' }}
              >
                <Inscription size="12px" color="textOnColor">
                  {index + 1}
                </Inscription>
              </Box>
              <ImgSquare src={documentPage?.link} />
            </ImgThumbInner>
          </ImgThumbOuter>
        </Box>
      ))}
    </Wrapper>
  );
};

export default ScanPagePreview;
